import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentMethodGiropayIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="135"
        height="87"
        viewBox="0 0 135 87"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Giropay</title>
        <rect
          x="1"
          y="1"
          width="132.692"
          height="85.2153"
          rx="4.86945"
          stroke={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          strokeWidth="1.21736"
        />
        <g clipPath="url(#clip0)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M86.3408 46.246C86.3408 46.8602 86.8886 47.2254 87.619 47.2254C88.7976 47.2254 89.528 46.163 89.528 45.1006C89.1296 45.084 88.6814 45.0508 88.2166 45.0508C87.1542 45.0508 86.3408 45.3828 86.3408 46.246Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77.0281 42.2773C75.8827 42.2773 75.1357 43.2733 75.1357 44.6179C75.1357 45.9293 75.9989 46.9087 77.0281 46.9087C78.2067 46.9087 78.9039 45.9293 78.9039 44.5017C78.9039 43.3065 78.2233 42.2773 77.0281 42.2773Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M102.559 26.7422H32.4408C28.8884 26.7422 26 29.614 26 33.1664V56.0744C26 59.6102 28.8884 62.482 32.4408 62.482H102.576C106.128 62.482 109.017 59.6102 109.017 56.0744V33.1664C109 29.614 106.112 26.7422 102.559 26.7422ZM69.409 59.8592H32.6566C30.4322 59.8592 28.6394 58.0664 28.6394 55.8586V33.3822C28.6394 31.1744 30.4488 29.3816 32.6566 29.3816H69.3924V59.8592H69.409ZM78.0078 49.285C76.9288 49.285 75.7502 48.8866 75.1692 47.8242H75.136V52.7046H72.0318V40.1052H74.887V41.732H74.9202C75.5344 40.4704 76.8458 39.906 78.2568 39.906C80.7302 39.906 82.0914 42.2632 82.0914 44.4378C82.108 47.0772 80.6804 49.285 78.0078 49.285ZM89.744 49.0858C89.7274 48.6044 89.6776 48.1396 89.6776 47.6748H89.6444C88.9306 48.8036 88.084 49.3016 86.8058 49.3016C85.0296 49.3016 83.4526 48.4218 83.4526 46.4796C83.4526 43.7406 86.4406 43.4086 88.084 43.4086C88.582 43.4086 89.1298 43.4584 89.5282 43.5248C89.5116 42.2964 88.5986 41.9644 87.4864 41.9644C86.4904 41.9644 85.4944 42.147 84.6312 42.645L84.5814 40.5368C85.677 40.0886 86.839 39.906 88.167 39.906C90.4578 39.906 92.4332 40.8854 92.4332 43.6244V46.961C92.4332 47.6748 92.4664 48.372 92.5992 49.0858H89.744ZM100.302 48.4716C99.4218 50.7292 98.7578 52.9204 95.9026 52.9204C95.2552 52.9204 94.6078 52.854 93.977 52.7046L94.1762 50.3474C94.5912 50.4802 94.973 50.53 95.4046 50.53C96.1682 50.53 96.7492 50.0818 96.965 49.285L93.3296 40.1052H96.6662L98.5918 45.965H98.625L100.468 40.1052H103.572L100.302 48.4716Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.2087 44.5217C36.2087 43.2933 36.8063 42.2807 37.9683 42.2807C39.3627 42.2807 39.9437 43.3929 39.9437 44.4055C39.9437 45.7833 39.0639 46.7129 37.9683 46.7129C37.0387 46.7129 36.2087 45.9161 36.2087 44.5217ZM42.9483 40.1061H40.1429V41.7329H40.1097C39.4457 40.6373 38.3833 39.9069 37.0553 39.9069C34.2665 39.9069 33.0049 41.9155 33.0049 44.5715C33.0049 47.2275 34.5321 49.0867 37.0055 49.0867C38.2505 49.0867 39.2797 48.6053 40.0267 47.5595H40.0599V48.0409C40.0599 49.8005 39.0971 50.6471 37.3043 50.6471C36.0095 50.6471 35.2127 50.3649 34.2665 49.9001L34.1171 52.3403C34.8309 52.6059 36.0593 52.9047 37.5367 52.9047C41.1555 52.9047 42.9483 51.7095 42.9483 48.0243V40.1061ZM48.1773 36.3711H45.0897V38.6453H48.1939V36.3711H48.1773ZM45.0897 49.0867H48.1939V40.1061H45.0897V49.0867ZM56.8093 40.0065C56.4939 39.9567 56.1121 39.9069 55.7635 39.9069C54.4189 39.9069 53.6387 40.6373 53.1075 41.7661H53.0743V40.1061H50.2523V49.0867H53.3565V45.3019C53.3565 43.5423 54.1699 42.4965 55.6141 42.4965C55.9793 42.4965 56.3113 42.4965 56.6599 42.5961L56.8093 40.0065ZM62.1545 47.1279C60.7269 47.1279 60.1459 45.9327 60.1459 44.6047C60.1459 43.2601 60.7269 42.0649 62.1545 42.0649C63.5821 42.0649 64.1631 43.2601 64.1631 44.6047C64.1631 45.9327 63.5821 47.1279 62.1545 47.1279ZM62.1545 49.2859C65.1093 49.2859 67.3669 47.5595 67.3669 44.6047C67.3669 41.6167 65.1093 39.8903 62.1545 39.8903C59.1997 39.8903 56.9421 41.6167 56.9421 44.6047C56.9421 47.5761 59.1997 49.2859 62.1545 49.2859Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect
              x="26"
              width="83"
              height="83"
              fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default PaymentMethodGiropayIcon;
